export default "__VITE_ASSET__qulkK$ZF__";